module.exports = __webpack_public_path__ + "img/vpn_key.e622f1a8.svg";